import { z } from "zod"

import { HeaderButtonNotifications } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonNotifications"
import { HeaderButtonReferAFriend } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonReferAFriend"
import dynamic from "next/dynamic"
import { rem, Skeleton } from "@mantine/core"

const HeaderButtonProfile = dynamic(() => import("./components/HeaderButtonProfile").then((mod) => mod.HeaderButtonProfile), {
  ssr: false,
  loading: () => <Skeleton width={rem(203)} height={rem(36)} opacity={0.2} />,
})

// const HeaderButtonSupport = dynamic(
//   () =>
//     import("./components/HeaderButtonSupport").then(
//       (mod) => mod.HeaderButtonSupport
//     ),
//   {
//     ssr: false,
//     loading: () => <Skeleton width={rem(36)} height={rem(36)} opacity={0.2} />,
//   }
// )

const HeaderButtonTypeEnum = z.enum([
  "ReferAFriend",
  // "SupportChat",
  "Notifications",
  "Profile",
])
type THeaderButtonType = z.infer<typeof HeaderButtonTypeEnum>

interface HeaderNavBarButtonProps {
  type: THeaderButtonType
}

export function HeaderNavBarButton({ type }: HeaderNavBarButtonProps) {
  switch (type) {
    case HeaderButtonTypeEnum.Enum.ReferAFriend:
      return <HeaderButtonReferAFriend />
    case HeaderButtonTypeEnum.Enum.Notifications:
      return <HeaderButtonNotifications />
    // case HeaderButtonTypeEnum.Enum.SupportChat:
    //   return <HeaderButtonSupport />
    case HeaderButtonTypeEnum.Enum.Profile:
      return <HeaderButtonProfile />
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>
  }
}
